import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  white,
  darkBlue,
  lightestBlue,
  MQ,
} from '@css/constants'
import { FontNormal } from '@css/fonts'

export const TRANSITION_DELAY = 400
const BREAKPOINT_LARGE = '995px'

export const getTranslationY = (state: string): number => {
  switch (state) {
    case 'exiting':
      return -100
    default:
      return 0
  }
}

export const ApptBannerWrapper = styled('div')<{ state: string, includeTimer: boolean }>(props => css`
  background: ${darkBlue};
  height: ${props.state === 'exiting' ? 0 : 48}px;
  transition: height ${TRANSITION_DELAY}ms;
  position: relative;
  width: 100%;
  z-index: ${props.state === 'entering' || props.state === 'exiting' ? -1 : 0};

  ${MQ.SMALL_SCREENS} {
    height: ${props.state === 'exiting' ? 0 : props.includeTimer ? 105 : 72}px;
  }
`)

export const InnerWrapper = styled('div')<{ state: string, includeTimer: boolean }>(props => css`
  color: ${white};
  align-items: center;
  justify-content: space-around;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  max-width: ${props.includeTimer ? `910px` : `610px`};

  transform: translateY(${getTranslationY(props.state)}%);
  transition: opacity ${TRANSITION_DELAY}ms, transform ${TRANSITION_DELAY}ms;
  opacity: ${props.state === 'entering' || props.state === 'exiting' ? 0 : 1};

  @media(max-width: ${BREAKPOINT_LARGE}) {
    max-width: 700px;
  }

  ${MQ.SMALL_SCREENS} {
    box-sizing: border-box;
    padding: 5px 8px;
    height: 100%;
  }
`)

export const MessageWrapper = styled('div')<{ includeTimer: boolean }>(props => css`
  ${FontNormal(600)};
  height: 100%;
  font-size: 16px;
  display: grid;
  margin-right: 6px;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: ${props.includeTimer ? `auto auto auto auto` : `auto auto`};;

  ${MQ.SMALL_SCREENS} {
    grid-template-columns: unset;
    grid-template-rows: auto;
    font-size: 14px;
    margin: 3px 0 0 32px;
    width: 80%;
  }
`)

export const IconWrapper = styled('div')(css`
  color: ${lightestBlue};
  margin-right: 6px;
  display: inline-block;
  position: relative;
  top: 2px;

  ${MQ.SMALL_SCREENS} {
    position: absolute;
    top: 8px;
    left: 12px;

    svg {
      height: 20px;
      width: 20px;
      top: 3px;
      position: relative;
    }
  }
`)

export const CloseBtnWrapper = styled('div')(css`
  position: absolute;
  right: 20px;
  top: 5px;

  @media(max-width: ${BREAKPOINT_LARGE}) {
    right: 8px;
  }
`)

export const ScheduleBtnTextMobile = styled('div')(css`
  display: none;

  ${MQ.SMALL_SCREENS} {
    display: block;
  }
`)

export const ScheduleBtnTextDesktop = styled('div')(css`
  display: block;

  ${MQ.SMALL_SCREENS} {
    display: none;
  }
`)

export const TimeRemainingWrapper = styled('div')(css`
  margin-left: 15px;
`)

export const TimeRemainingMobileWrapper = styled('div')(css`
  display: none;
  margin-top: 6px;
  width: 100%;
  place-content: center;

  ${MQ.SMALL_SCREENS} {
    display: grid;
  }
`)

export const scheduleButtonStyles = css`
  font-size: 14px; /* forcing a fixed font size: */
  max-width: 193px;
  padding: 0;
  white-space: break-spaces;
  margin-left: 5px;

  & > * {
    ${FontNormal(600)};
  }

  ${MQ.SMALL_SCREENS} {
    margin: 0 auto;
  }
`

export const closeButtonStyles = css`
  padding: 0;
  height: 40px;
  width: 40px;

  & > svg {
    color: ${white};
    height: 20px;
    width: 20px;
  }

  ${MQ.SMALL_SCREENS} {
    right: 4px;
    top: 2px;
  }
`
